module.exports = __webpack_public_path__ + "img/TirePressureMonitoring.03b48840.png";